<template>
    <div>
        <el-dialog title="选择视频" :visible.sync="visible" width="800px" :close-on-click-modal="false">
            <el-row style="margin-top: -20px" type="flex" justify="space-between">
                <div></div>
                <el-form size="small" :model="query" inline @submit.native.prevent>
                    <el-form-item>
                        <el-input v-model="query.search_keyword" placeholder="请输入视频标题" clearable @keyup.enter.native="handleSearch"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-radio-group style="width: 100%" v-model="pickedUUid">
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    row-key="uuid"
                    ref="table"
                    size="small"
                    header-cell-class-name="table-header"
                    border
                    style="margin: 20px 0"
                >
                    <el-table-column prop="name" label="视频标题"></el-table-column>
                    <el-table-column prop="category.name" label="视频分类"></el-table-column>
                    <el-table-column prop="create_time" label="上传时间"></el-table-column>
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="{ row }">
                            <el-radio :label="row.uuid"><span style="font-size: 0">1</span></el-radio>
                        </template>
                    </el-table-column>
                </el-table>
            </el-radio-group>
            <el-row type="flex" justify="end">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="query.page_index"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </el-row>
            <span slot="footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirm">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import listMixin from "@/mixins/list";
import { list } from "@/api/video/list";
export default {
    data() {
        return {
            list,
            visible: false,
            query: {
                search_keyword: "",
            },
            pickedUUid: "",
        };
    },
    mixins: [listMixin],
    methods: {
        open() {
            this.visible = true;
            this.pickedUUid = "";
            this.search();
        },
        search() {
            const params = {
                ...this.query,
                page_size: 9999,
            };
            this._search(params);
        },
        handleConfirm() {
            if (this.pickedUUid) {
                const name = this.tableData.find((item) => item.uuid === this.pickedUUid).name;
                this.$emit("pick", { name, uuid: this.pickedUUid });
                this.visible = false;
            } else {
                this.$message.warning("请选择视频");
            }
        },
    },
};
</script>

<style lang="less" scoped>
:deep(.el-radio__label) {
    padding-left: 0;
}
</style>
